<template>
  <v-container
    class="bg-transparent"
    fluid
    v-if="
      settings.accountId !== '' &&
      settings.placementId !== '' &&
      settings.placementExists
    "
  >
    <DataFetcher v-if="settings.initialized" v-slot="{ data, error, loading }">
      <v-sheet class="mx-auto bg-transparent" max-width="100%">
        <!-- Wrap v-overlay in a div for proper transition -->
        <v-fade-transition>
          <div v-if="!fontsLoaded && !fontsError">
            <v-overlay contained class="align-center justify-center">
              <v-progress-circular indeterminate />
            </v-overlay>
          </div>
        </v-fade-transition>
      </v-sheet>
      <ItemList
        v-if="loading || (data && data.items && data.items.length > 0)"
        :items="data && data.items && data.items.length > 0 ? data.items : []"
        :loading="loading"
      />
    </DataFetcher>
  </v-container>
</template>

<script setup lang="ts">
import DataFetcher from './components/DataFetcher.vue'
import ItemList from './components/ItemList.vue'
import { useSettingsStore } from '@/stores/settings'
import { useGoogleFonts } from './composables/useGoogleFonts'
import { onMounted, ref } from 'vue'

const settings = useSettingsStore()

const { loadFonts, extractUniqueFonts } = useGoogleFonts()
const fontsLoaded = ref(false)
const fontsError = ref<string | null>(null)

onMounted(async () => {
  try {
    if (settings.accountId !== '') {
      await settings.fetchSettings()
    }

    if (settings.initialized) {
      const fontsToLoad = extractUniqueFonts(settings.placementSettings)

      if (fontsToLoad.length > 0) {
        await loadFonts(fontsToLoad)
        fontsLoaded.value = true
      }
    }
  } catch (error) {
    fontsError.value =
      error instanceof Error ? error.message : 'Failed to load fonts'
    console.error('Font loading error:', error)
  }
})
</script>

<style scoped></style>
